import React,{ Component } from 'react';

import {
  Card,
  CardBody,
  Row,Col,Button
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import { checkStatusOfUser } from '../utils';

class OnboardingHiImMary extends Component {
  constructor(){
    super();

    this.state = {
      checkedUserStatus:false,
      userExists:null,
      error:null
    };
  }

  componentDidMount(){
    const params = this.props.queryStringParams;

    if(params && params.email && params.userId && params.token){
      checkStatusOfUser(params.email)
        .then((res) => this.setState({checkedUserStatus:true,userExists:res.active}))
        .catch((err) => this.setState({checkedUserStatus:true,error:err}));
        
    } else {
      this.setState({checkedUserStatus:true,error:new Error('Invalid link')})
    }
  }

  getMessage(){
    const { error, userExists } = this.state;

    if(error){
      return 'Looks like you have a bad welcome link.';
    }

    if(userExists){
      return 'Looks like you already have an account.';
    } else {
      return 'Let\'s start by creating your account.';
    }
  }

  getLink(){
    const { error, userExists } = this.state;

    const { isInvite, location } = this.props;

    if(error){
      return 'mailto:campaignhelp@getdabbl.com'; 
    }

    if(userExists){
      return '/login'; 
    } else if(isInvite){
      return `/invite/signup${location.search}`;
    } else {
      return `/welcome/signup${location.search}`;
    }
  }

  getButtonText(){
    const { error, userExists } = this.state;

    if(error){ 
      return 'Lets get this figured out';
    }

    if(userExists){ 
      return 'Log in';
    } else { 
      return 'Okay';
    }     
  }

  render(){
    const {checkedUserStatus,error} = this.state;

    return (
      <div className='OnboardingHiImMary'>
        <br />
        <br />
        <Row>
          <Col xs={12} sm={{size:8,offset:2}}>
            <Card 
              className='FadeIn' 
              style={{
                opacity:checkedUserStatus ? 1 : 0
              }}
            >
              <CardBody className='CardContent'>
                <Row>
                  <Col xs='12' sm={{size:8,offset:2}}>
                    <img 
                      src={require('../assets/Mary.jpg')} 
                      alt='Mary Roddy' 
                    />
                    <br />
                    <br />
                    <h2>Let's get you set up!</h2>
                    <br />
                    <p>
                      Hi I'm Mary, Product Manager at Dabbl.
                    </p>
                    <p>
                      I'm here to help you get set up and engaging with consumers.&nbsp;&nbsp;  
                      {this.getMessage()}
                    </p>
                    <br />
                    {error ? (
                      <a 
                        className='btn btn-primary' 
                        href='mailto:campaignhelp@getdabbl.com'
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;{this.getButtonText()}&nbsp;&nbsp;&nbsp;&nbsp;
                      </a>
                    ) : (
                      <Button
                        color="primary"
                        tag={Link}
                        to={this.getLink()}
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;{this.getButtonText()}&nbsp;&nbsp;&nbsp;&nbsp;
                      </Button>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

OnboardingHiImMary.propTypes = {
  //TODO: Fill in prop types for OnboardingHiImMary
};

OnboardingHiImMary.defaultProps = {
  //TODO: Fill in defaultProps for OnboardingHiImMary
};

export default OnboardingHiImMary;



// WEBPACK FOOTER //
// ./src/routes/OnboardingHiImMary/components/OnboardingHiImMary.js